import { render, staticRenderFns } from "./ModalIndicationViewDetail.vue?vue&type=template&id=5a55b4aa&scoped=true"
import script from "./ModalIndicationViewDetail.vue?vue&type=script&lang=js"
export * from "./ModalIndicationViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalIndicationViewDetail.vue?vue&type=style&index=0&id=5a55b4aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55b4aa",
  null
  
)

export default component.exports